import http from "../../utils/httpClient"
import {getCaseId} from "../../utils/UrlParser"
import {getRequestConfigWithAuth} from "../../utils/auth"

export const PdfProofActionTypes = {
    UpdateWatermark: "UPDATE_WATERMARK",
    GenerateProof: "GENERATE_PROOF",
    GenerateProofFailure: "GENERATE_PROOF_FAILURE",
    EmailProof: "EMAIL_PROOF",
    EmailProofFailure: "EMAIL_PROOF_FAILURE"
  };

class DesignService {
	logAction = (
		actionType: string,
        metadata?: any
	) => {
		let actionLog = {
			actionType: actionType,
            actionMetaData: metadata
		}
		this.postActionLog(actionLog)
	}

    async postActionLog(actionLog: any): Promise<boolean> {
		const caseId = getCaseId()
		return http
			.post(
				`${process.env.REACT_APP_CARE_DESIGN_SERVICE}/api/v1/actionLogs/?caseId=${caseId}`,
				actionLog,
				getRequestConfigWithAuth()
			)
			.then(() => {
				return true
			})
			.catch((err) => {
				console.error(err)
				throw new Error("Failed to log the action.")
			})
	}
	
}

export const DesignServiceDependency = new DesignService()